import logger from '~/config/app.logger';
import { GET_ADMIN_USER_ROLES_ENDPOINT, LOGGER_NAME } from '../config/constants';
import { getExtendedLogger } from '@mindtickle/ui-shell-core/Logger';
//@ts-ignore
import { get } from '@mindtickle/api-helpers';
import type { TLocalAuthContext } from '~/components/Auth';

const log = getExtendedLogger(LOGGER_NAME, logger);

type CanLoadFreshchatProps = {
  isAdmin: boolean;
  auth: TLocalAuthContext | undefined;
};

const getAdminRoles = async (auth: TLocalAuthContext | undefined): Promise<string[]> => {
  if (!auth) return [];

  try {
    const response = await get({
      url: `${GET_ADMIN_USER_ROLES_ENDPOINT}?cname=${auth.company?.id}`,
    });
    return response?.admin_user_roles || [];
  } catch (error) {
    log('Error fetching admin roles', error, auth?.company?.id, 'Unable to access Freshchat.');
    return [];
  }
};

const userHasAdminAccess = async (auth: TLocalAuthContext | undefined): Promise<boolean> => {
  const adminRoles = await getAdminRoles(auth);
  const userRoles = auth?.user?.roles || [];
  return userRoles.some(role => adminRoles.includes(role));
};

const canLoadFreshchat = async ({ isAdmin, auth }: CanLoadFreshchatProps): Promise<boolean> => {
  if (!isAdmin) return false;
  const hasAdminAccess = await userHasAdminAccess(auth);
  return hasAdminAccess;
};

export default canLoadFreshchat;
